<template>
  <div class="container">
    <div class="opt_container">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="客户名称：">
                <el-input v-model="param.customerName" placeholder="客户名称" wi></el-input>
            </el-form-item>
            <el-form-item label="对接人：">
                <el-input v-model="param.contacts" placeholder="对接人"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="table_container">
        <el-table :data="tableData" style="width: 100%" height="100%" @sort-change="sortChange">
            <el-table-column type="index" label="序号" width="100" />
            <el-table-column prop="customerName" label="客户名称" />
            <el-table-column prop="customerCode" label="客户代码" />
            <el-table-column prop="envTypeText" label="环境类型" />
            <el-table-column :sortable="'custom'" label="到期时间">
                <template slot-scope="scope">
                    <span>{{ !scope.row.endDate ? '-' : scope.row.endDate }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="contacts" label="对接人" />
            <el-table-column prop="contactsNumber" label="对接人电话" />
            <el-table-column label="授权类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkType == 1">按门店及导购授权</span>
                    <span v-else-if="scope.row.checkType == 3">按导购点数授权</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native.prevent="gotoDetail(scope.$index)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="page_container">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="param.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="param.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :hide-on-single-page="hidePage">
        </el-pagination>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api/api'
export default {
    name: "list",
    data() {
    return {
        hidePage: true,
        total: 0,
        tableData: [],
        param: {
            customerName: '',
            contacts: '',
            size: 10,
            page: 1,
            sortType: ''
        }
    };
    },
    created() {
        // this.loadData()
        console.log('created')
    },
    methods: {
        handleSizeChange(val) {
            this.param.size = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.param.page = val
            this.loadData()
        },
        sortChange(param) {
            switch (param.order) {
                case 'ascending':
                this.param.sortType = 'asc'
                break
                case 'descending':
                this.param.sortType = 'desc'
                break
                default:
                this.param.sortType = ''
                break
            }
            this.onSubmit()
        },
        onSubmit() {
            this.loadData(true)
        },
        loadData(reload) {
            if(this.param.customerName == '' && this.param.contacts == '') {
                this.$message({
                    message: '请输入 客户名称 或 对接人',
                    type: 'warning'
                });
                return
            }

            if(reload) {
                this.param.page = 1
            }
            getInfo(this.param).then(res => {
                console.log(res)
                this.total = res.data.total
                this.tableData = res.data.list
            })
        },
        gotoDetail(index) {
            let obj = this.tableData[index]
            this.$router.push({
                path: 'detail',
                query: {
                    cid: obj['cid'],
                    cName: obj['customerName']
                }
            })
        },
    },
};
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        height: 100vh;
    }
    .opt_container {
        height: 100px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 20px;
    }
    .table_container {
        padding: 0 20px;
        flex: 1;
        overflow: hidden;
    }
    .page_container {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
  


// WEBPACK FOOTER //
// src/pages/list.vue